import React from 'react';
import { Divider, Typography } from '@mui/material';
import molaDelaPutiMas from '../../../../../images/Agri-info/fish/deshimas_মলা, ঢেলা ও পুঁটি মাছ.jpg';
import useDocumentTitle from '../../../../../hooks/useDocumentTitle';

const MolaDelaPutiMasInfo = () => {

    // dynamic title
    useDocumentTitle("মলা, ঢেলা ও পুঁটি মাছ");

    return (

        <div className=" rounded-3 bg-white my-4 px-5">
            <Typography
                sx={{
                    textAlign: "center",
                    pb: 2,
                    pt: 3,
                    fontWeight: 600,
                    color: 'rgb(37, 36, 36, 0.83)'
                }}
                variant="h4"
                component="div"
            >
                মলা, ঢেলা ও পুঁটি মাছ
            </Typography>
            <Divider />

            <div className="card mt-4 mb-3 border-0 rounded-0">
                <div className="row g-0">
                    <div className="col-md-4">
                        <img src={molaDelaPutiMas} className="img-fluid rounded-0 h-100" alt="..." />
                    </div>
                    <div className="col-md-8">
                        <div className="card-body text-start ">
                            <p className="card-text"><b>মাছ চাষের বৈশিষ্ট্য</b><br />
                                •    একক ও মিশ্র উভয় পদ্ধতিতে চাষ করা হয়।<br />
                                •    প্রাকৃতিকভাবে বছরে ২-৩ বার প্রজনন করে থাকে।<br />
                                •    সহজ ব্যবস্থাপনায় চাষ করা যায়।<br />
                                •    যে কোন ছোট জলাশয়ে চাষ করা যায়। </p>
                            <p className="card-text"><b>পুকুর নির্বাচন</b><br />
                                •    জলাশয়টি বন্যামুক্ত হতে হবে।<br />
                                •    পানির গভীরতা ১-১.৫ মিটার হলে ভালো হয়।<br />
                                •    জলাশয়ে আলো বাতাসের ব্যবস্থা থাকতে হবে।</p>

                        </div>
                    </div>
                </div>
            </div>

            <div className='text-start pb-5'>
                <p className="card-text"><b>প্রস্তুতি, পোনা মজুদ, খাদ্য ও সার প্রয়োগ</b><br />
                    •    পুকুরের পাড় মেরামত করে শতাংশ প্রতি ১ কেজি চুন ও ৪-৫ কেজি গোবর প্রয়োগ করতে হবে।<br />
                    •    সার প্রয়োগের ৩-৪ দিন পর প্রাকৃতিক খাদ্য জন্মালে ছোট মাছ ছাড়তে হবে।<br />
                    •    একক চাষের ক্ষেত্রে শতাংশ প্রতি ৪০০-৫০০ টি মলা/ঢেলা/পুটির চাষ করা যায়।<br />
                    •    মাছ ছাড়ার পর দিন হতে মাছের দেহ ওজনের শতকরা ৫-১০% ভাগ হিসাবে চালের কুড়া, গমের ভূষি ও সরিষার খৈল সম্পুরক খাবার হিসেবে দেয়া যেতে পারে।<br />
                    •   প্রাকৃতিক খাবার তৈরীর জন্য ৭ দিন অন্তর অন্তর শতাংশ প্রতি ৫-৬ কেজি গোবর অথবা ২-৩ কেজি হাঁস- মুরগীর বিষ্টা দিলে ভাল ফল পাওয়া যায়।</p>
                <p className="card-text"><b>ছোট মাছ সংরক্ষণ কৌশল</b><br />পুকুরে ছোট মাছকে অবাঞ্ছিত মাছ হিসেবে গণ্য না করে সেগুলোকে বৈজ্ঞানিক পদ্ধতিতে সংরক্ষণ ও চাষের আওতায় আনতে হবে। জলজ পরিবেশের সুষ্ঠু ব্যবস্থাপনার মাধ্যমে ছোট মাছের বংশ বিস্তারের সুযোগ সৃষ্টি করে এর উৎপাদন বাড়াতে হবে।</p>
                <p className="card-text">•    স্থানীয়ভাবে প্রাপ্য দেশীয় প্রজাতির ছোট মাছ পুকুরে মজুদ ও সংরক্ষণ করা।<br />
                    •    ছোট মাছের বংশ বৃদ্ধির জন্য পুকুরে নিয়ন্ত্রিত মাত্রায় কিছু জলজ আগাছা রাখা।<br />
                    •    জলাশয় বা পুকুর সম্পূর্ণ সেচে সকল মাছ আহরণ না করা ।<br />
                    •    ছোট মাছের প্রজনন মৌসুম (জ্যৈষ্ঠ-আষাঢ়) সম্পর্কে সংশিৱষ্ট জনগণকে সচেতন করা এবং সে সময় পুকুরে ছোট ফাঁসের জাল টানা থেকে বিরত থাকা।<br />
                    •    ধানক্ষেতে ছোট প্রজাতির মাছ চাষের ব্যবস্থা করা যেতে পারে।</p>








                <p className="card-text"><b>প্রাকৃতিক জলাশয়ে</b><br />
                    •    বিল, হাওর ও বাওরে অভয়াশ্রম স্থাপন করা।<br />
                    •    ছোট মাছের প্রধান প্রজনন মৌসুম বৈশাখ থেকে আষাঢ় মাস, এ সময় প্রাকৃতিক জলাশয়ে মাছ ধরা বন্ধ রাখা।<br />
                    •    জলাশয়ের পানি সেচে মাছ না ধরা।<br />
                    •    ছোট মাছের গুরুত্ব ও এর সংরক্ষণ সম্পর্কে জলাশয়ের আশেপাশের জনগণকে সচেতন করা এবং সংরক্ষণ কাজে সম্পৃক্ত করা।<br />
                    •    মৌসুমী জলাভূমিগুলোর কিছু অংশ খনন করে প্রজননৰম মাছ সংরক্ষণ করা, যাতে তারা বর্ষা মৌসুমে ডিম পাড়তে পারে।</p>

            </div>
        </div >


    );
};

export default MolaDelaPutiMasInfo;